/**
 * Parse external referrer host for analytics (no path/query — avoids leaking search terms).
 */
export function getExternalReferrerHost(): string {
  if (typeof document === 'undefined' || !document.referrer) {
    return '';
  }
  try {
    const ref = new URL(document.referrer);
    if (typeof window !== 'undefined' && ref.origin === window.location.origin) {
      return '';
    }
    return ref.host;
  } catch {
    return '';
  }
}

/**
 * UTM and campaign query params from a search string (TelemetryDeck web parity).
 */
export function getCampaignParams(search: string): Record<string, string> {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  const out: Record<string, string> = {};
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'source', 'ref'] as const;
  for (const key of keys) {
    const value = params.get(key)?.trim();
    if (value) {
      out[key] = value;
    }
  }
  return out;
}
